import Vue from 'vue';
import stream from './stream.js'
if(document.getElementById('lector-stream')){
    let lectorStream = new stream({
        el:"#lector-stream",
        data:{
            currentLectorQuest:1,
            currentLectorPull:1,
        },
        methods:{
            onVote:function(data){
                this.pulls[data.pull_id].answers = data.results;
                var allVotes = 0;

                for (var pull in this.pulls[data.pull_id].answers) {

                    allVotes += this.pulls[data.pull_id].answers[pull].result.votes

                }

               this.pulls[data.pull_id]['no_voted'] = {
                   clients:0,
                   percent:0
               };

               this.pulls[data.pull_id].no_voted.clients = this.clients - allVotes;
               this.pulls[data.pull_id].no_voted.percent = Math.floor((this.clients - allVotes) * 100 / this.clients) ;

            },
            scrollChat:function(){
                return true;
            }
        }

    });
    Offline.on('confirmed-up',function () {

        lectorStream.netMessage = false;
    });
    Offline.on('confirmed-down',function () {

        lectorStream.netMessage = true;

    });
}
